const root = '/purchase';

export default {
  root,
} as const;
